module.exports = __webpack_public_path__ + "static/educative-walkthrough-poster-c93b315f4b4ef46f63c5a026c6b232b6.jpg";